
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useClientAnalytics = () => {
  return useQuery({
    queryKey: ["client-analytics"],
    queryFn: async () => {
      // جلب إحصائيات العملاء حسب الحالة
      const { data: clientsData, error: clientsError } = await supabase
        .from("clients")
        .select(`
          status,
          created_at,
          companies!inner(name_ar),
          client_assignments(
            employees(name, department)
          )
        `);

      if (clientsError) throw clientsError;

      // تحليل العملاء حسب الحالة
      const statusAnalysis = clientsData.reduce((acc: any, client) => {
        const status = client.status || 'غير محدد';
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});

      // تحليل العملاء حسب الشهر
      const monthlyAnalysis = clientsData.reduce((acc: any, client) => {
        const month = new Date(client.created_at).toLocaleString('ar-SA', { 
          year: 'numeric', 
          month: 'long' 
        });
        acc[month] = (acc[month] || 0) + 1;
        return acc;
      }, {});

      // تحليل العملاء حسب المسؤول
      const employeeAnalysis = clientsData.reduce((acc: any, client) => {
        const assignments = client.client_assignments || [];
        assignments.forEach((assignment: any) => {
          if (assignment.employees) {
            const employeeName = assignment.employees.name;
            acc[employeeName] = (acc[employeeName] || 0) + 1;
          }
        });
        return acc;
      }, {});

      return {
        totalClients: clientsData.length,
        statusAnalysis,
        monthlyAnalysis,
        employeeAnalysis,
        recentClients: clientsData.slice(-5)
      };
    },
  });
};
